import svgIcons from "../assets/svg/svgIcons";
import { MODAL_TYPE } from "../constants/constants";
import { AdminFormFieldSubmit } from "./admin/formFields";

interface ReportErrorModalProps {
  heading: string;
  type: MODAL_TYPE;
  subHeading?: string;
  onHide: () => void;
  containerStyle?: string;
  showOverlay?: boolean;
  isError?: boolean;
  ActionButtons?: React.ReactNode;
}

export const ReportErrorModal = (props: ReportErrorModalProps) => {
  return (
    <div className={`${props?.showOverlay ? "fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay" : "max-w-[480px]"}`}>
      <div className="fixed max-w-[480px] bottom-0 right-10 z-overlay">
        <div className={`relative my-6 mx-auto z-modal`}>
          <div className="p-8 bg-white rounded-3xl shadow-2xl">
            <div className="flex flex-row justify-between items-center mb-4">
              <label className={`text-lg mr-16 font-bold leading-6 ${props.type === "success"
                ? "text-green-600" : props.type === "error" ? "text-red-600" : "text-black"}`}>
                {props.heading}
              </label>
              <img src={props.type === "error" ? svgIcons.Error : props.type === 'success' ? svgIcons.Success : svgIcons.Loading}
                alt="info"
                className={`size-6 ${(props.type !== "success" && props.type !== 'error') && "animate-spin"}`} />
            </div>
            <div className="flex flex-col gap-2">
              {props.subHeading && (
                <span className="text-heading-gray888 Xline-clamp-3">
                  {props.subHeading}
                </span>
              )}
              {props.ActionButtons}
              <AdminFormFieldSubmit
                type="button"
                variant="danger-transparent"
                onClick={props.onHide}
                label={(
                  <span className={`text-sm font-bold text-red-600`}>
                    {"Close"}
                  </span>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}